export default __webpack_public_path__ + "static/media/FOIL_ALUMINIUM_120X278_001_265.21d3510c.jpg";